import * as React from 'react';
import { Typography } from '@material-ui/core';
import { useFormikContext } from 'formik';
export var BError = function (_a) {
    var name = _a.name, id = _a.id, className = _a.className;
    var _b = useFormikContext(), errors = _b.errors, status = _b.status;
    return (React.createElement(Typography, { id: id, variant: "caption", display: "block", color: "error", style: { paddingLeft: '1px' }, className: className },
        errors && errors[name],
        status && status[name]));
};
//# sourceMappingURL=BError.js.map